/* ============================================================
   FCN — Smaltimento per-variante (W104)
   ------------------------------------------------------------
   Filtro di VISIBILITÀ sui paragrafi già renderizzati da
   `metafield_tag` (metafield product-level `custom.smaltimento`,
   rich_text). NON ricostruisce e NON modifica il testo: agisce
   solo sull'attributo `hidden`. Il dato regolato (codici materiale
   ex art. 219 c.5 D.Lgs. 152/2006 / Dec. 97/129/CE) resta
   intatto e, in assenza/ambiguità di match, è mostrato INTERO.

   Regola FAIL-OPEN: nel dubbio si mostra tutto, mai una
   "migliore approssimazione".

   Dipende (se presenti) dai global di Dawn (classic script, lexical):
     subscribe / PUB_SUB_EVENTS.variantChange
   NB: PUB_SUB_EVENTS è una `const` top-level (constants.js) -> NON è su window;
       vanno referenziati per nome nudo, non come window.*.
   Evento Dawn 15.4.1: { data: { sectionId, html, variant } }
   ============================================================ */
(function () {
  'use strict';
  if (window.__fcnSmaltimentoLoaded) return;
  window.__fcnSmaltimentoLoaded = true;

  var CONTAINERS = [
    'airless', 'foamer', 'flacone', 'bottiglia', 'bustina', 'stick',
    'vaso', 'vasetto', 'barattolo', 'tubo', 'tubetto', 'spray', 'astuccio'
  ];

  /* ---------- util ---------- */

  function norm(s) {
    return String(s == null ? '' : s)
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // accenti
      .replace(/(\d)[.,](\d)/g, '$1.$2')                // 4,5 -> 4.5
      .replace(/[^\w.\s]/g, ' ')                         // toglie ( ) ® ecc.
      .replace(/\s+/g, ' ')
      .trim();
  }

  function tokens(s) {
    var n = norm(s);
    var volumes = [];
    var re = /(\d+(?:\.\d+)?)\s*(ml|cl|l|g|kg)\b/g, m;
    while ((m = re.exec(n)) !== null) volumes.push(m[1] + m[2]);
    var containers = CONTAINERS.filter(function (c) {
      return new RegExp('\\b' + c + '\\b').test(n);
    });
    return { containers: containers, volumes: volumes, norm: n };
  }

  function readConfig(block) {
    var el = block.querySelector('[data-fcn-smaltimento-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // sectionId come lo calcola product-info.js: originalSection || section
  function sectionIdOf(block) {
    var pi = block.closest('product-info');
    if (pi) return pi.dataset.originalSection || pi.dataset.section || null;
    return block.getAttribute('data-section-id') || null;
  }

  // variante corrente al load: <script data-selected-variant> dentro lo stesso product-info
  function currentVariant(block) {
    var pi = block.closest('product-info') || document;
    var el = pi.querySelector('[data-selected-variant]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function getFormato(config, variant) {
    if (!config || !variant || !Array.isArray(variant.options)) return null;
    var opts = Array.isArray(config.options) ? config.options : [];
    var idx = -1;
    for (var i = 0; i < opts.length; i++) {
      if (String(opts[i]).trim().toLowerCase() === 'formato') { idx = i; break; }
    }
    if (idx < 0) return null;
    return variant.options[idx] != null ? variant.options[idx] : null;
  }

  /* ---------- parsing DOM (struttura prodotta da metafield_tag) ----------
     header  = <p> con testo prevalentemente in <strong>/<b>, o <h2..h4>
     riga    = <p> normale dopo un header
     disclaim= ultimo <p> prevalentemente in <em>/<i> (sempre visibile)        */

  function isHeader(el) {
    if (/^H[2-4]$/.test(el.tagName)) return true;
    var txt = el.textContent.trim();
    if (!txt) return false;
    var b = el.querySelector('strong, b');
    return !!b && b.textContent.trim().length >= txt.length * 0.8;
  }
  function isDisclaimer(el) {
    var txt = el.textContent.trim();
    if (!txt) return false;
    var em = el.querySelector('em, i');
    return !!em && em.textContent.trim().length >= txt.length * 0.8;
  }

  function parse(content) {
    var container = content.querySelector('.metafield-rich_text_field') || content;
    var paras = Array.prototype.filter.call(container.children, function (el) {
      return /^(P|H2|H3|H4|DIV|LI)$/.test(el.tagName) && el.textContent.trim() !== '';
    });

    var disclaimer = null;
    for (var i = paras.length - 1; i >= 0; i--) {
      if (isDisclaimer(paras[i]) && !isHeader(paras[i])) { disclaimer = paras[i]; break; }
    }

    var sections = [], cur = null;
    paras.forEach(function (el) {
      if (el === disclaimer) return;
      if (isHeader(el)) {
        cur = { headerText: el.textContent.trim(), blocks: [el] };
        sections.push(cur);
      } else if (cur) {
        cur.blocks.push(el);
      }
      // righe orfane prima del primo header: restano sempre visibili
    });

    return { paras: paras, sections: sections, disclaimer: disclaimer };
  }

  function matchSection(formato, sections, formatMap) {
    var cand;
    // 1) override esplicito (etichette non regolate)
    if (formatMap && formatMap[formato]) {
      var target = norm(formatMap[formato]);
      cand = sections.filter(function (s) { return norm(s.headerText) === target; });
      if (cand.length === 1) return cand[0];
    }
    // 2) match esatto normalizzato
    var nf = norm(formato);
    cand = sections.filter(function (s) { return norm(s.headerText) === nf; });
    if (cand.length === 1) return cand[0];
    // 3) contenitore + volume (gestisce "Flacone 200 ml e 100 ml")
    var ft = tokens(formato);
    cand = sections.filter(function (s) {
      var ht = tokens(s.headerText);
      var cMatch = ft.containers.some(function (c) { return ht.containers.indexOf(c) !== -1; });
      var vMatch = ft.volumes.some(function (v) { return ht.volumes.indexOf(v) !== -1; });
      return cMatch && vMatch;
    });
    if (cand.length === 1) return cand[0];
    // 0 o >1 candidati -> fail-open
    return null;
  }

  /* ---------- applicazione ---------- */

  function apply(block, variant) {
    var content = block.querySelector('[data-fcn-smaltimento-content]');
    if (!content) return;
    var parsed = parse(content);
    var sectionParas = parsed.sections.reduce(function (acc, s) { return acc.concat(s.blocks); }, []);

    function showAll() { parsed.paras.forEach(function (p) { p.hidden = false; }); }

    // niente da filtrare: 0/1 sezione, oppure variante assente
    if (parsed.sections.length <= 1) { showAll(); return; }
    if (!variant) { showAll(); return; }

    var config = readConfig(block);
    var formato = getFormato(config, variant);
    if (!formato) { showAll(); return; }

    var matched = matchSection(formato, parsed.sections, config && config.formatMap);
    if (!matched) {
      showAll();
      if (window.console) console.warn('[FCN smaltimento] match incerto: fallback completo', {
        product: config && config.productId, variant: variant && variant.id, formato: formato
      });
      return;
    }

    // nascondi tutte le sezioni, mostra solo quella scelta; disclaimer e orfani restano visibili
    sectionParas.forEach(function (p) { p.hidden = true; });
    matched.blocks.forEach(function (p) { p.hidden = false; });
    if (parsed.disclaimer) parsed.disclaimer.hidden = false;
  }

  /* ---------- init + eventi ---------- */

  function initBlock(block) {
    if (block.dataset.fcnSmaltimentoInit === '1') return;
    block.dataset.fcnSmaltimentoInit = '1';
    apply(block, currentVariant(block));
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-fcn-smaltimento]').forEach(initBlock);
  }

  function start() {
    initAll(document);

    // ri-init dopo quick-add / product swap (Dawn rimpiazza il nodo product-info)
    document.addEventListener('product-info:loaded', function (e) {
      initAll(e.target || document);
    });

    // aggiornamento al cambio variante dello stesso prodotto.
    // PUB_SUB_EVENTS è una const top-level di Dawn (NON su window) e subscribe è
    // un global classico: si referenziano per nome nudo. `typeof` su identificatore
    // non dichiarato è l'unico accesso che non lancia ReferenceError -> guardia sicura.
    if (typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
        var data = payload && payload.data ? payload.data : {};
        var blocks = document.querySelectorAll('[data-fcn-smaltimento]');
        Array.prototype.forEach.call(blocks, function (block) {
          if (sectionIdOf(block) === data.sectionId) apply(block, data.variant || null);
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
